<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <baseMessage :disabled="true" view type="comment" @getDetail="getDetail" />
        <commitList
          ref="commitListRef"
          :permissionPage="{
            delCommit: 'lbu_sale_coaching_del_commit'
          }"
          :data="detail.commentList"
          :score=detail.score
          :id="route.query.id"
        />
        <a-form name="detailsForm" ref="formRef" :model="form" v-if="commentComputed">
          <dc-layout-card title="评论">
            <span v-if="detail.score <= 0">
              <a-rate style="margin-left: 20px;margin-bottom: 16px;margin-top: -10px;" v-model:value="form.score" :tooltips="commentDesc" :disabled="detail.score > 0" />
              <span class="ant-rate-text">{{ commentDesc[form.score - 1] }}</span>
            </span>
            <a-col :span="24">
              <Editor
                v-model:value="form.content"
                :maxlength="3000"
                v-model:mention="form.userCodes"
                placeholder="请输入评论"
              />
            </a-col>
            <dc-form-item label="上传附件" name="fileId" :span="24">
              <UploadFile v-model:value="form.fileId" valueType="array" />
            </dc-form-item>
          </dc-layout-card>
        </a-form>
      </CosViewContent>
      <cos-footer-button :loading="loading" hideOk>
        <a-button
          v-show="commentComputed && activeKey === 'base'"
          type="primary"
          @click="handleCommit"
          :loading="loading"
          v-permission="'lbu_sale_coaching_comment_btn'"
          >发表</a-button
        >
      </cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import baseMessage from '../components/baseMessage.vue'
import commitList from '../components/commitList.vue'
import Editor from '@/components/Editor'
import UploadFile from '@/components/UploadFile'
import { DcMessage } from '@dc-platform/dc-components'
import { saleCoachingCommentCreate } from '@/api/yuntuSales/saleCoaching'
import type {
  LbuSaleCoachingCommentItem,
  LbuSaleCoachingCommentParams,
  LbuSaleCoachingDetail
} from '@/typings/api/saleCoaching'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
const router = useRouter()
const route = useRoute()
const form = ref<LbuSaleCoachingCommentItem>({
  fileId: []
})

const commentDesc = ref<string[]>(['非常不满意', '不满意', '一般', '满意', '非常满意'])

const props = defineProps({
  type: {
    default: String
  }
})
const activeKey = ref('base')
const loading = ref(false)
const detail = ref({})
const commitListRef = ref()
const showComment = ref(false)
const commentComputed = computed(() => {
  if (props.type === 'comment') {
    return true
  }
  return showComment.value
})

const handleCommit = () => {
  // if (!form.value.score) {
  //   DcMessage.warning('请输入评论内容')
  //   return
  // }

  if (!form.value.content) {
    DcMessage.warning('请输入评论内容')
    return
  }
  loading.value = true
  // 评论必填
  saleCoachingCommentCreate({
    salesCoachingId: route.query.id,
    ...form.value
  })
    .then((res) => {
      DcMessage.success('发表成功')
      layoutTags.close()
    })
    .finally(() => {
      loading.value = false
    })
}
const getDetail = (data: LbuSaleCoachingDetail) => {
  detail.value = data
  form.value.score = data.score
}
</script>
